import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_d9me6u99: FaireBrandEntity = {
  token: "b_d9me6u99",
  type: "brand",
  name: "Freestone",
  avatarUrl: "https://cdn.faire.com/fastly/84df7c3d3af50800a04ff8b61ab3082a0565bcd4a7d882364db8a233095a52b5.jpeg",
  bannerUrl: "https://cdn.faire.com/fastly/e49f07fec908436950ea031585b74daa8f09a39e6406f208a7cf6d397a8058dd.jpeg",
  logoUrl: "https://cdn.faire.com/fastly/84df7c3d3af50800a04ff8b61ab3082a0565bcd4a7d882364db8a233095a52b5.jpeg",
  heroImageUrl: "https://cdn.faire.com/fastly/e49f07fec908436950ea031585b74daa8f09a39e6406f208a7cf6d397a8058dd.jpeg",
  location: "Eureka, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 8,
  isTopShop: true,
  isInsider: true,
  description: "Freestone is a collection of handmade beaded, gemstone and 14k gold-filled jewelry. featuring fun and unassuming color combinations. ",
  meta: {
    source: "api",
    importedAt: "2026-10-14T17:08:03.810Z",
    importedBy: "entity-db-cli"
  }
};
